/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



$(document).ready(function() {
  $(document).on('click', '.nav-dropdown-close-btn', function() {
      const $dropdownItem = $(this).closest('.is-dropdown-open');

      $dropdownItem.removeClass('is-dropdown-open').find('> a[data-type="menuitem"]').attr('aria-expanded', 'false');
      
      $dropdownItem.find('> ul.nav-dropdown').attr('aria-hidden', 'true');
      
      $dropdownItem.closest('ul.nav-bar__linklist').removeClass('nav-dropdown--glued');
      // $('body').removeClass('dropdown-open');

      // Toggle class on the nested nav-dropdown inside menuitem-image-with-info
      $('.menuitem-image-with-info.has-dropdown').find('> .nav-dropdown--floating').removeClass('second-dropdown-open');
      
      // Toggle class on the .nav-bar__item > .nav-dropdown
      $('.menuitem-image-with-info.has-dropdown').closest('.nav-bar__item').find('> .nav-dropdown').removeClass('second-dropdown-open');
      $('.menuitem-image-with-info.has-dropdown').removeClass('second-dropdown-open');

      $('.full-width-sub-mega-menu-wrap.full-width-mega-menu-item').removeClass('active');
    
  });
  // Open detection (when menu is opened elsewhere)
    $(document).on('click', '.header .nav-bar .nav-bar__linklist>.nav-bar__item>.nav-bar__link[aria-haspopup="true"]', function() {
        // $('body').addClass('dropdown-open');
          setTimeout(initializeFlickitySlider, 100); // Adjust delay if needed
          setTimeout(initializeFlickitySliderV2, 100); // Adjust delay if needed
          setTimeout(function(){
            equalheight(".nav-dropdown .full-width-mega-menu-item .menuitem-image-with-info-inner-grid.has-slider .menuitem-image-with-info .info .title");
          },100);
          
    });
});

// $(function () {
//   const $header = $(".header");
//   let lastScroll = 0;

//   function updateStickyClass() {
//     const headerTop = $header[0].getBoundingClientRect().top;

//     if (headerTop <= 0) {
//       $header.addClass("sticky");
//     } else {
//       $header.removeClass("sticky");
//     }
//   }

//   $(window).on("scroll resize load", function () {
//     const currentScroll = $(this).scrollTop();

//     // Optional throttle
//     if (Math.abs(currentScroll - lastScroll) > 1) {
//       updateStickyClass();
//       lastScroll = currentScroll;
//     }
//   });
// });

$(function () {
  const $header = $(".header");
  let isSticky = false;

  function updateStickyClass() {
    const headerTop = $header[0].getBoundingClientRect().top;

    // Add sticky when header reaches the top
    if (headerTop <= 0 && !isSticky) {
      $header.addClass("sticky");
      isSticky = true;
    }

    // Remove sticky only when scrolled back to the very top
    if (window.scrollY === 0 && isSticky) {
      $header.removeClass("sticky");
      isSticky = false;
    }
  }

  $(window).on("scroll resize load", updateStickyClass);
});


// $(document).ready(() => {
//   const toggleClasses = (clickedElement) => {
//     $(clickedElement).find('> .nav-dropdown--floating').toggleClass('second-dropdown-open');
//     $(clickedElement).closest('.nav-bar__item').find('> .nav-dropdown').toggleClass('second-dropdown-open');
//     $(clickedElement).toggleClass('second-dropdown-open');
//   };

//   const removeClasses = () => {
//     $('.nav-dropdown--floating, .nav-bar__item > .nav-dropdown, .menuitem-image-with-info.has-dropdown').removeClass('second-dropdown-open');
//   };

//   // Click handler for menu item
//   $('.menuitem-image-with-info.has-dropdown').on('click', function(e) {
//     // e.preventDefault();
//     e.stopPropagation();
//      /* --- NEW: reset the scroll position of the parent dropdown --- */
//     $(this).closest('.nav-bar__item').find('> .nav-dropdown').scrollTop(0);
//     toggleClasses(this);
//   });

//   // Click handler for back button
//   $('.nav-dropdown-back-btn').on('click', function(e) {
//     e.preventDefault();
//     e.stopPropagation();
//     removeClasses();
//   });

//   // Optional: Close dropdowns when clicking outside
//   $(document).on('click', function() {
//     removeClasses();
//   });

//   // Only prevent propagation for specific elements, not the entire dropdown
//   $('.menuitem-image-with-info.has-dropdown, .nav-dropdown-back-btn').on('click', function(e) {
//     e.stopPropagation();
//   });

//   // Set interval
//   if ($(window).width() <= 768) {
//     console.log('aaa', $(window).width());
//     const load_annoucement_bar = setInterval(function(){
//       var $countdownBar = $('.essential_countdown_annoucement_bar_wrapper');
//       if ($countdownBar.length && $('.stickey_annoucement_bar_wrapper').length) {
//         $countdownBar.detach().appendTo('.stickey_annoucement_bar_wrapper');
//         clearInterval(load_annoucement_bar);
//       }
//     },10);

//     setTimeout(function(){
//       clearInterval(load_annoucement_bar);
//     },5000);
//   }
// });


$(document).ready(() => {
  /* ---------- helpers ---------- */
  const removeClasses = ($root) => {
    $root
      .find('.second-dropdown-open')
      .addBack('.second-dropdown-open')   // also the root itself
      .removeClass('second-dropdown-open');
  };

  /* ---------- event handlers (delegated) ---------- */

  // 1. Open / toggle the second-level dropdown
  $(document).on('click', '.menuitem-image-with-info.has-dropdown', function (e) {
    e.stopPropagation();          // keep document handler from closing it immediately
    const $this        = $(this);
    const $mainDrop    = $this.closest('.nav-bar__item').find('> .nav-dropdown');

    // optional: if you want only ONE open at a time inside the same nav-bar
    // removeClasses($this.closest('.nav-bar'));

    // $mainDrop.scrollTop(0);       // reset scroll as requested
    window.scrollTo(0, 0);
    $this.toggleClass('second-dropdown-open');
    $this.find('> .nav-dropdown--floating').toggleClass('second-dropdown-open');
    $mainDrop.toggleClass('second-dropdown-open');
  });

  $('.full-width-mega-menu .nav-dropdown__item.has-dropdown').on('click', function (e) {
    e.preventDefault(); // prevent default anchor behavior
    const targetSelector = $(this).find('> a.nav-dropdown__link').attr('href');
    const $targetSubmenu = $(targetSelector);
    window.scrollTo(0, 0);

    // Close all other submenus
    $('.full-width-sub-mega-menu-wrap').not($targetSubmenu).removeClass('active');

    // Toggle the current submenu
    $targetSubmenu.addClass('active');
     setTimeout(initializeFlickitySlider, 100); // Adjust delay if needed
     setTimeout(initializeFlickitySliderV2, 100); // Adjust delay if needed
      setTimeout(function(){
        equalheight(".nav-dropdown .full-width-mega-menu-item .menuitem-image-with-info-inner-grid.has-slider .menuitem-image-with-info .info .title");
      },100);
  });

  // 2. Back button inside any dropdown
  $(document).on('click', '.nav-dropdown-back-btn', function (e) {
    e.preventDefault();
    e.stopPropagation();
    removeClasses($(this).closest('.nav-bar'));   // closes only inside this nav-bar

    const targetSelector = $(this).find('> a.nav-dropdown__link').attr('href');
    const $targetSubmenu = $(targetSelector);

    // Close all other submenus
    $('.full-width-sub-mega-menu-wrap').not($targetSubmenu).removeClass('active');
  });

  // 3. Close everything when clicking outside
  $(document).on('click', function (event) {
  // If the click is not inside any element with 'second-dropdown-open'
  if (!$(event.target).closest('.second-dropdown-open').length) {
      const $dropdownItem = $(this).closest('.is-dropdown-open');

      $dropdownItem.removeClass('is-dropdown-open').find('> a[data-type="menuitem"]').attr('aria-expanded', 'false');
      
      $dropdownItem.find('> ul.nav-dropdown').attr('aria-hidden', 'true');
      
      $dropdownItem.closest('ul.nav-bar__linklist').removeClass('nav-dropdown--glued');
      // $('body').removeClass('dropdown-open');

      // Toggle class on the nested nav-dropdown inside menuitem-image-with-info
      $('.menuitem-image-with-info.has-dropdown').find('> .nav-dropdown--floating').removeClass('second-dropdown-open');
      
      // Toggle class on the .nav-bar__item > .nav-dropdown
      $('.menuitem-image-with-info.has-dropdown').closest('.nav-bar__item').find('> .nav-dropdown').removeClass('second-dropdown-open');
      $('.menuitem-image-with-info.has-dropdown').removeClass('second-dropdown-open');

      $('.full-width-sub-mega-menu-wrap.full-width-mega-menu-item').removeClass('active');
    }
  }); 
  // $(document).on('click', function () {
  //   $('.second-dropdown-open').removeClass('second-dropdown-open');
  // });

  // Set interval
  // if ($(window).width() <= 768) {
  //   console.log('aaa', $(window).width());
  //   const load_annoucement_bar = setInterval(function(){
  //     var $countdownBar = $('.essential_countdown_annoucement_bar_wrapper');
  //     if ($countdownBar.length && $('.stickey_annoucement_bar_wrapper').length) {
  //       $countdownBar.detach().appendTo('.stickey_annoucement_bar_wrapper');
  //       clearInterval(load_annoucement_bar);
  //     }
  //   },10);

  //   setTimeout(function(){
  //     clearInterval(load_annoucement_bar);
  //   },5000);
  // }

});

function initializeFlickitySliderV2() {
  const elems = document.querySelectorAll('.full-width-mega-menu-item .full-width-mega-menu.has-slider-v2');

  elems.forEach(function (elem) {
    // Prevent double init
    if (elem.classList.contains('flickity-initialized')) return;

    const waitUntilVisible = () => {
      const isVisible = !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
      if (isVisible) {
        // Initialize Flickity
        const flkty = new Flickity(elem, {
          cellAlign: "left",
          wrapAround: false,
          prevNextButtons: true,
          draggable: true,
          contain: true,
          lazyLoad: true,
          groupCells: true,
          pageDots: false,
          arrowShape: "M45.107632 5.82952 L53.53207 14.795201 L24.285714 46.292352 L97.808833 46.292352 L97.808833 59.383744 L24.285714 59.383744 L53.53207 90.877568 L45.107615 99.952178 L1.377755 53.778731 L45.107632 5.82952 Z"
        });

        // Force Flickity to recalculate layout after short delay
        setTimeout(() => {
          flkty.resize();
        }, 100);

        elem.classList.add('flickity-initialized');
      } else {
        setTimeout(waitUntilVisible, 50);
      }
    };

    waitUntilVisible();
  });
}




function initializeFlickitySlider() {
  const sliderContainers = document.querySelectorAll(
    ".full-width-mega-menu-item .full-width-mega-menu.has-slider"
  );

  sliderContainers.forEach((sliderContainer) => {
    // Skip if already initialized
    if (sliderContainer.classList.contains("carousel-initialized")) return;

    const items = sliderContainer.querySelectorAll(".nav-dropdown__item");
    if (!items.length) return;

    // Store the original items before clearing
    const clonedItems = Array.from(items).map((item) => item.cloneNode(true));

    // Clear and prepare the slider
    sliderContainer.innerHTML = "";
    sliderContainer.classList.add("carousel", "carousel-initialized");

    // Group items into slides (2 per slide)
    for (let i = 0; i < clonedItems.length; i += 2) {
      const cell = document.createElement("div");
      cell.className = "carousel-cell";

      cell.appendChild(clonedItems[i]);
      if (clonedItems[i + 1]) cell.appendChild(clonedItems[i + 1]);

      sliderContainer.appendChild(cell);
    }

    // Wait for the container to be visible before initializing Flickity
    const checkVisibilityAndInit = () => {
      if (sliderContainer.offsetParent !== null) {
        // Force reflow
        void sliderContainer.offsetHeight;

        const flickity = new Flickity(sliderContainer, {
          cellAlign: "left",
          wrapAround: false,
          prevNextButtons: true,
          draggable: true,
          contain: true,
          lazyLoad: true,
          groupCells: true,
          pageDots: false,
          arrowShape:
            "M45.107632 5.82952 L53.53207 14.795201 L24.285714 46.292352 L97.808833 46.292352 L97.808833 59.383744 L24.285714 59.383744 L53.53207 90.877568 L45.107615 99.952178 L1.377755 53.778731 L45.107632 5.82952 Z"
        });

        // Optional: Adjust container height to Flickity content
        flickity.on("ready", () => {
          sliderContainer.style.height = `${flickity.size.height}px`;
        });
      } else {
        // Retry until visible
        setTimeout(checkVisibilityAndInit, 50);
      }
    };

    checkVisibilityAndInit();
  });
}


jQuery(document).ready(function () {
      equalheight = function (container) {
        var currentTallest = 0,
          currentRowStart = 0,
          rowDivs = new Array(),
          $el,
          topPosition = 0;
        jQuery(container).each(function () {
          $el = jQuery(this);
          jQuery($el).height("auto");
          topPostion = $el.position().top;

          if (currentRowStart != topPostion) {
            for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
              rowDivs[currentDiv].height(currentTallest);
            }
            rowDivs.length = 0; // empty the array
            currentRowStart = topPostion;
            currentTallest = $el.height();
            rowDivs.push($el);
          } else {
            rowDivs.push($el);
            currentTallest =
              currentTallest < $el.height() ? $el.height() : currentTallest;
          }
          for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
            rowDivs[currentDiv].height(currentTallest);
          }
        });
      };
      jQuery(window).on("load resize", function () {
              equalheight(".nav-dropdown .full-width-mega-menu-item .menuitem-image-with-info-inner-grid.has-slider .menuitem-image-with-info .info .title");
      });
});


$(document).ready(() => {
    const targetSelector = '.essential_countdown_annoucement_bar_wrapper';
    let $target = null;

    // Function to update the CSS variable
    const updateHeightVar = () => {
      if ($target && $target.length) {
        const height = $target.outerHeight();
        document.documentElement.style.setProperty('--app-announcement-bar-height', `${height}px`);
      }
    };

    // MutationObserver to detect when the element is added to DOM
    const observer = new MutationObserver((mutationsList, observer) => {
      for (let mutation of mutationsList) {
        if (mutation.type === 'childList') {
          $target = $(targetSelector);
          if ($target.length) {
            updateHeightVar();
            observer.disconnect(); // Stop observing once found
            break;
          }
        }
      }
    });

    // Start observing
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Also update on window resize
    $(window).on('resize', () => {
      updateHeightVar();
    });

    // Optional: timeout to stop observer after 20s
    setTimeout(() => observer.disconnect(), 20000);
});

